/**
 * @generated SignedSource<<4699041176bfaa175ad2d1fd5b49fc7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeaderUserFragment$data = {
  readonly name: string | null | undefined;
  readonly rawId: number | null | undefined;
  readonly username: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"AvatarFragment">;
  readonly " $fragmentType": "HeaderUserFragment";
};
export type HeaderUserFragment$key = {
  readonly " $data"?: HeaderUserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderUserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeaderUserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarFragment"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "babe50d4b4aa2774ad106584a380aad9";

export default node;
